import type { ComponentProps, ReactNode } from 'react';

import { Slot } from '@radix-ui/react-slot';
import { LoaderCircleIcon } from 'lucide-react';
import type { VariantProps } from 'tailwind-variants';

import { buttonStyles } from './styles/button.style';

type Props = ComponentProps<'button'> &
  VariantProps<typeof buttonStyles> & {
    asChild?: boolean;
    isLoading?: boolean;
    loader?: ReactNode;
  };

export function Button({
  asChild = false,
  className,
  disabled = false,
  float,
  floatPosition,
  isLoading = false,
  loader = <LoaderCircleIcon className="text-background animate-spin" />,
  rounded,
  size,
  textTransform,
  type = 'button',
  variant,
  ...props
}: Props) {
  const Comp = asChild ? Slot : 'button';

  return (
    <Comp
      className={buttonStyles({
        variant,
        size,
        className,
        disabled,
        rounded,
        float,
        floatPosition,
        textTransform,
      })}
      data-slot="button"
      disabled={disabled || isLoading}
      type={type}
      {...props}
    >
      {isLoading ? loader : props.children}
    </Comp>
  );
}
